const initialState = {
    vkey: "",
    username: "",
}

const Identificador = (state = initialState, action) => {
    switch (action.type) {
        case "SET_IDENTIFICA":
            return { ...state, 
                vkey: action.payload.vkey, 
                username: action.payload.username
              }
            //break;
        default:
            break;
    }

    return state;
}

export default Identificador;